import { useState, useCallback } from "react";

/**
 * Iter121z · Hook per aggiungere drag & drop al caricamento file.
 *
 * @param {(files: File[]) => any} onDrop  callback invocato quando file vengono rilasciati
 * @param {{disabled?: boolean}} [opts]
 * @returns {{ dragProps: object, isDragOver: boolean }}
 *
 * Uso:
 *   const { dragProps, isDragOver } = useDropZone(handleFiles);
 *   return <div {...dragProps} className={isDragOver ? "border-brand" : ""}>...</div>
 */
export function useDropZone(onDrop, opts = {}) {
  const [isDragOver, setIsDragOver] = useState(false);

  const handleDragOver = useCallback((e) => {
    if (opts.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    if (!isDragOver) setIsDragOver(true);
  }, [isDragOver, opts.disabled]);

  const handleDragEnter = useCallback((e) => {
    if (opts.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(true);
  }, [opts.disabled]);

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    // Ignora se sposto tra figli dello stesso container
    if (e.currentTarget.contains(e.relatedTarget)) return;
    setIsDragOver(false);
  }, []);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);
    if (opts.disabled) return;
    const files = Array.from(e.dataTransfer?.files || []);
    if (files.length === 0) return;
    onDrop(files);
  }, [onDrop, opts.disabled]);

  return {
    isDragOver,
    dragProps: {
      onDragOver: handleDragOver,
      onDragEnter: handleDragEnter,
      onDragLeave: handleDragLeave,
      onDrop: handleDrop,
    },
  };
}
